import { useCallback, useEffect, useState } from 'react';
import { parsePayload } from './model';

const getJSON = (url, signal) =>
  fetch(url, { signal }).then((r) => {
    if (!r.ok) throw new Error('http-' + r.status);
    return r.json();
  });

/** Obtencion de datos (solo GET publicos, mismos endpoints que el calendario original). */
export default function useSchedule(urls) {
  const [state, setState] = useState({ status: 'loading' });
  const [attempt, setAttempt] = useState(0);
  const { cozumel, calica } = urls;

  useEffect(() => {
    const ac = new AbortController();
    setState({ status: 'loading' });
    if (!cozumel || !calica) {
      setState({ status: 'error' });
      return undefined;
    }
    Promise.all([getJSON(cozumel, ac.signal), getJSON(calica, ac.signal)])
      .then(([a, b]) => {
        if (ac.signal.aborted) return;
        setState({ status: 'ready', cozumel: parsePayload(a), calica: parsePayload(b) });
      })
      .catch(() => {
        if (!ac.signal.aborted) setState({ status: 'error' });
      });
    return () => ac.abort();
  }, [cozumel, calica, attempt]);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  return { ...state, retry };
}
